import { render } from "./EditTeamModal.vue?vue&type=template&id=53df2b9c"
import script from "./EditTeamModal.vue?vue&type=script&lang=js"
export * from "./EditTeamModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\diloti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__